module.exports = __webpack_public_path__ + "img/img36.d493a52e.svg";